<template>
  <div
    v-html="title"
    :style="{ width, backgroundColor: color }"
    class="tag"
  />
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    }
  }
};
</script>

<style lang="scss">
  .tag {
    background: $blue;
    color: $white;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
  }
</style>
